import { useState } from "react";
import { Vendor } from "../types";
import { useParams } from "react-router-dom";
import VendorModal from "../components/VendorModal";
import { Button, useMediaQuery } from "@mui/material";
import { useAppSelector } from "../hooks";
import { handleVendorClick } from "../api";
import { getSortedVendors } from "../utils";

interface Props {}

function Vendors(props: Props) {
  const [showModal, setShowModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState<Vendor>();
  const isDesktop = useMediaQuery("(min-width: 720px)");

  const vendorTypes = useAppSelector((state) => state.app.vendorTypes);

  const { id } = useParams();

  const vendorType = vendorTypes.find((v) => v.id === id);

  const vendors = useAppSelector((state) => state.app.vendors)
    .filter((v) => v.type?.id === vendorType?.id)
    .sort((a, b) => a.name.localeCompare(b.name));

  const onVendorClickedHandler = async (vendor?: Vendor) => {
    setShowModal(true);
    setSelectedVendor(vendor);

    if (!vendor?.id) return;
    try {
      await handleVendorClick(vendor.id);
    } catch (error) {
      console.error("Error handling vendor click:", error);
    }
  };

  const closeModal = () => {
    setSelectedVendor(undefined);
    setShowModal(false);
  };

  return (
    <>
      {vendorType && (
        <VendorModal
          closeModal={closeModal}
          open={showModal}
          vendor={selectedVendor}
          vendorType={vendorType}
        />
      )}
      <div className="vendors">
        <div className="header-container">
          <h2>{vendorType?.name}</h2>
        </div>
        <div className="vendors-container">
          {getSortedVendors(vendors, vendorType?.vendorOrderPointer ?? 0)
            .filter((v) => v.visible)
            .map((vendor) => (
              <div
                onClick={() => !isDesktop && onVendorClickedHandler(vendor)}
                key={vendor.id}
                className="vendor"
              >
                <img
                  src={vendor.logo ?? vendorType?.logo ?? ""}
                  className="logo"
                  alt=""
                />
                <div className="vendor-name">{vendor.name}</div>

                {isDesktop && (
                  <div className="contact-container">
                    <div className="location">{vendor.located || "-"}</div>

                    <Button
                      onClick={() => onVendorClickedHandler(vendor)}
                      variant="outlined"
                      sx={{ fontFamily: "Belleza", letterSpacing: "2px" }}
                    >
                      Info
                    </Button>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default Vendors;
